module.exports = __webpack_public_path__ + "static/media/first-house.965fe377.jpg";